var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { cn } from '../../../lib/utils.js';
function Card(_a) {
    var className = _a.className, _b = _a.size, size = _b === void 0 ? 'default' : _b, props = __rest(_a, ["className", "size"]);
    return (<div data-slot="card" data-size={size} className={cn('group/card bg-card text-card-foreground ring-foreground/10 flex flex-col gap-4 overflow-hidden rounded-xl py-4 text-sm ring-1 has-data-[slot=card-footer]:pb-0 has-[>img:first-child]:pt-0 data-[size=sm]:gap-3 data-[size=sm]:py-3 data-[size=sm]:has-data-[slot=card-footer]:pb-0 *:[img:first-child]:rounded-t-xl *:[img:last-child]:rounded-b-xl', className)} {...props}/>);
}
function CardHeader(_a) {
    var className = _a.className, props = __rest(_a, ["className"]);
    return (<div data-slot="card-header" className={cn('group/card-header @container/card-header grid auto-rows-min items-start gap-1 rounded-t-xl px-4 group-data-[size=sm]/card:px-3 has-data-[slot=card-action]:grid-cols-[1fr_auto] has-data-[slot=card-description]:grid-rows-[auto_auto] [.border-b]:pb-4 group-data-[size=sm]/card:[.border-b]:pb-3', className)} {...props}/>);
}
function CardTitle(_a) {
    var className = _a.className, props = __rest(_a, ["className"]);
    return (<div data-slot="card-title" className={cn('cn-font-heading text-base leading-snug font-medium group-data-[size=sm]/card:text-sm', className)} {...props}/>);
}
function CardDescription(_a) {
    var className = _a.className, props = __rest(_a, ["className"]);
    return (<div data-slot="card-description" className={cn('text-muted-foreground text-sm', className)} {...props}/>);
}
function CardAction(_a) {
    var className = _a.className, props = __rest(_a, ["className"]);
    return (<div data-slot="card-action" className={cn('col-start-2 row-span-2 row-start-1 self-start justify-self-end', className)} {...props}/>);
}
function CardContent(_a) {
    var className = _a.className, props = __rest(_a, ["className"]);
    return (<div data-slot="card-content" className={cn('px-4 group-data-[size=sm]/card:px-3', className)} {...props}/>);
}
function CardFooter(_a) {
    var className = _a.className, props = __rest(_a, ["className"]);
    return (<div data-slot="card-footer" className={cn('bg-muted/50 flex items-center rounded-b-xl border-t p-4 group-data-[size=sm]/card:p-3', className)} {...props}/>);
}
export { Card, CardHeader, CardFooter, CardTitle, CardAction, CardDescription, CardContent };
